type ToggleVariant = 'bordered' | 'bare';

type ToggleType = {
  name: string;
  onChange: () => void;
  text: string;
  checked: boolean;
  disabled?: boolean;
  // "bordered" wraps the pill and its label in a single outlined control (the
  // default). "bare" renders the pill alone for call sites with no label text
  // or where the surrounding layout supplies its own frame.
  variant?: ToggleVariant;
};

const Toggle = ({
  name,
  onChange,
  text,
  checked = false,
  disabled = false,
  variant = 'bordered'
}: ToggleType) => {
  const isBordered = variant === 'bordered';

  return (
    <label
      htmlFor={name}
      data-testid={`toggle-${name}`}
      className={`inline-flex items-center gap-2 whitespace-nowrap select-none font-open-sans text-sm text-neutral-800 ${
        isBordered
          ? 'h-[38px] rounded-[10px] border border-neutral-300 bg-white px-3'
          : ''
      } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
    >
      <input
        id={name}
        name={name}
        type="checkbox"
        role="switch"
        className="peer sr-only"
        checked={checked}
        disabled={disabled}
        aria-checked={checked}
        onChange={onChange}
      />
      <span
        aria-hidden="true"
        className={`inline-flex h-[17px] w-[30px] shrink-0 items-center rounded-full px-[3px] transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-primary-600 peer-focus-visible:ring-offset-2 ${
          checked
            ? 'justify-end bg-primary-600'
            : 'justify-start bg-neutral-400'
        }`}
      >
        <span className="h-[11px] w-[11px] rounded-full bg-white" />
      </span>
      {text && <span>{text}</span>}
    </label>
  );
};

export default Toggle;
